import * as React from 'react';
// @ts-ignore
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import { parse } from 'url';
import { compose } from 'recompose';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { translate } from '../utils/translateUtils';

const enhance = compose(translate, passApplication);

const WithdrawModalView = ({
  baseUrl,
  onClose,
  application: { authorization, settings, history },
  lng
}) => {
  const appConfig = {
    graphqlGateway: settings.get('graphqlGateway'),
    utcomGateway: {
      rest: {
        url: parse(settings.get('grpcGateway').url)
      }
    }
  };

  const conversionMF = settings.get('conversionMF', false);

  const homeUrl = baseUrl.replace(/\/withdraw.*$/, '');

  return (
    <Parcel
      config={() => import('@unitedtraders/withdraw-microfrontend')}
      mountParcel={mountRootParcel}
      locale={lng}
      getTokens={() => authorization.getTokens()}
      appConfig={appConfig}
      basename={baseUrl}
      closeModal={onClose}
      openExchangeModal={() =>
        conversionMF
          ? history.push(`${homeUrl}/conversion`)
          : (window.location.href = '/account?action=conversion')
      }
    />
  );
};

export const WithdrawModal = enhance(WithdrawModalView);



// WEBPACK FOOTER //
// ./src/components/WithdrawModal.jsx